import { render, staticRenderFns } from "./BlockEditMenu.vue?vue&type=template&id=da248484&scoped=true&"
import script from "./BlockEditMenu.vue?vue&type=script&lang=js&"
export * from "./BlockEditMenu.vue?vue&type=script&lang=js&"
import style0 from "./BlockEditMenu.vue?vue&type=style&index=0&id=da248484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da248484",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VIcon,VMenu})
